import { Badge } from './ui/badge';
import { Card, CardContent } from './ui/card';

interface GuardianLevelBadgeProps {
  level: number;
  title: string;
  experience: number;
  nextLevelExp: number;
}

export function GuardianLevelBadge({ level, title, experience, nextLevelExp }: GuardianLevelBadgeProps) {
  const levelIcons = [
    'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947026009_7be2d52f.webp',
    'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947027763_0e378c92.webp',
    'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947029501_cf02328f.webp',
    'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947031233_ab918398.webp',
    'https://d64gsuwffb70l.cloudfront.net/68b55da3cc8df3f651647221_1757947032941_d752ec71.webp'
  ];

  const progress = (experience / nextLevelExp) * 100;

  return (
    <Card className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 border-purple-500/50">
      <CardContent className="p-6">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <img 
              src={levelIcons[Math.min(level - 1, levelIcons.length - 1)]} 
              alt={`Level ${level}`} 
              className="w-16 h-16 opacity-90"
            />
            <Badge className="absolute -top-2 -right-2 bg-purple-600 text-white">
              {level}
            </Badge>
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold text-white mb-1">{title}</h3>
            <p className="text-purple-300 text-sm mb-2">Guardian Level {level}</p>
            <div className="w-full bg-purple-900/30 rounded-full h-2">
              <div 
                className="bg-gradient-to-r from-purple-500 to-blue-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="text-xs text-purple-400 mt-1">
              {experience}/{nextLevelExp} XP to next level
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}